export default __webpack_public_path__ + "static/media/social-action-benefit.e9ac4c95.svg";